import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfigurationDataService } from '../configuration-data.service';
import { SharedDataService } from '../shared-data.service';

@Component({
  selector: 'pl-login-status',
  templateUrl: './login-status.component.html',
  styleUrls: ['./login-status.component.css']
})
export class LoginStatusComponent implements OnInit {

  constructor(public shared: SharedDataService, private config: ConfigurationDataService,
    private router: Router) { }

  ngOnInit() {
  }

  public logout() {
    this.shared.setLoginData({ credentials: { username: "", userId: 0, token: "" }, isLoggedIn: false });
    this.router.navigate(['login']);
  }

  public settings() {
    this.router.navigate(['login','settings']);
  }

}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login-status/login-status.component.ts